const setOpeningModal = (name) => ({
  type: 'SET_OPENING_MODAL',
  payload: name,
});

export const closeModal = () => setOpeningModal(null);

export const openModal = (name) => setOpeningModal(name);
